/**
 * The new-card modal opens once per offer per visit. A visit is the tab's
 * session (sessionStorage); with storage blocked it opens once per mount,
 * which is the same thing for a single page view.
 */
const PREFIX = "aotd-new-card-seen:";

export function wasNewCardSeen(offerId: string): boolean {
  try {
    return window.sessionStorage.getItem(PREFIX + offerId) === "1";
  } catch {
    return false;
  }
}

export function markNewCardSeen(offerId: string): void {
  try {
    window.sessionStorage.setItem(PREFIX + offerId, "1");
  } catch {
    // storage blocked (private mode, previews): the modal may show again next visit
  }
}
